import React, { useState, useEffect, JSX } from 'react'
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting, DataGridTypes } from 'devextreme-react/data-grid';
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import { APIGetLoggersModel, BuildApiGetLoggers } from '../../models/APIGetLoggersModel'
import { Chip, useTheme, Menu, MenuItem, Button } from '@mui/material';
import { isLCLLogger } from 'variables/chariotProductIds';
import { Redirect } from "react-router-dom";
import Loader from '../../Utils/Loader/NewLoader2025'
import {useTabletContext } from '../../Context/ContextProvider'


interface RedirectProps {
    serial: number | undefined;
}


interface DeviceData {
    id: number;
    serial: string;
    latestSignal: number | null;
    model: string
    siteName: string | null
    siteNameUserFriendly: string | null
}


const PoorSignalMobile: React.FC = () => {

    const [loading, setLoading] = useState<boolean>(true)
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps | undefined>()
    const [devices, setDevices] = useState<Array<DeviceData>>([])
    const intl = useIntl()
    const theme = useTheme()
    const isTablet = useTabletContext()

    const reloadData = ():void => {
        CallGetAPI(CreateUrl('/api/Dashboard/poorsignal?companyid=' + sessionStorage.getItem('companyId') + '&filterGroup=' + sessionStorage.getItem('filterGroupId')), {})
            .then(data => {
                const deviceDataTemp = []
                if (data?.length > 0) {
                    // Copy the data records into deviceData, adding the clickEvent
                    deviceDataTemp.length = 0; //clear dummy data
                    for (let i = 0; i < data.length; i++) {
                        console.log(data[i])
                        const serial = data[i].serial;
                        const id = parseInt(data[i].id);
                        const rec: DeviceData = {
                            id: id,
                            serial: serial,
                            latestSignal: data[i].latestSignal,
                            model: data[i].model,
                            siteName: data[i].siteName,
                            siteNameUserFriendly: data[i].siteNameUserFriendly
                        };
                        deviceDataTemp.push(rec);
                    }
                    setDevices(deviceDataTemp)
                    setLoading(false)
                }
                else {
                    setDevices([])
                    setLoading(false)
                }
            })
            .catch(function (err) {
                setLoading(false)
                setDevices([])
                console.error(err)
            });
    }

    useEffect(() => {
        reloadData()
    }, [])

    const renderOverviewButton = (data: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        return <Button color="secondary" variant="contained" onClick={(): void => deviceOverviewClick(data.data.serial, data.data.model)}><FormattedMessage id='Overview' /></Button>
    }

    const deviceOverviewClick = (serial: number | undefined, model: string | undefined): void => {
        console.log(serial, model)
        setRedirect(true)
        setRedirectPath(!isLCLLogger(model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        setRedirectProps({ serial: serial })
    }

    const serialColumnTemplate = (item: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        console.log(item)

        return (<Chip
            label={item.data.serial}
            sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
            onClick={(): void => deviceOverviewClick(item.data.Serial, item.data.Model)}
        //onContextMenu={(e): void => handleContextMenu(e, item.data.serial, item.data.model)}
        />)
    }

    


    return (<>
        {loading ? <div style={{
            position: 'relative', left: 'Calc(50% - 100px)', minHeight: 200
        }}>
            <Loader color={undefined} />
        </div> :
            !redirect ? (<div>
                <Card>
                    <CardHeader color="primary">
                        <h4 style={{ textAlign: "center" }}>{intl.formatMessage({ id: 'Devices where Signal strength (CSQ) has been less than 8, in the last 24 hours' })}</h4>
                    </CardHeader>
                    <CardBody>

                        <DataGrid
                            dataSource={devices}
                            scrolling={{
                                mode: 'standard',
                                useNative: false
                            }}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                        >
                            <FilterRow visible={true} />
                            <HeaderFilter visible={true} allowSearch={true} />
                            <Column dataField="Serial" dataType="string" cellRender={(data): JSX.Element => serialColumnTemplate(data)} caption={intl.formatMessage({ id: "Serial" })} width={77} />
                            {isTablet && <Column dataField="siteName" caption={intl.formatMessage({ id: "Site Ref" })} />}
                            {isTablet && <Column dataField="siteNameUserFriendly" caption={intl.formatMessage({ id: "Site Name" })} />}
                            <Column dataField="latestSignal" caption={intl.formatMessage({ id: "Latest Signal" })} allowHeaderFiltering={true} />
                            <Column cellRender={(data): JSX.Element => renderOverviewButton(data)} caption={intl.formatMessage({ id: "Details" })} />
                        </DataGrid>
                    </CardBody>
                </Card>
            </div>) :
                <Redirect push to={{
                    pathname: redirectPath,
                    state: redirectProps
                }} />}
    </>)
}
export default PoorSignalMobile